import { ReactNode } from "react";
import { Container } from "./styles";

interface IRoot {
  children: ReactNode;
  className?: string;
}

export const PageRoot: React.FC<IRoot> = ({ children, className }) => {
  return <Container className={className}>{children}</Container>;
};
